import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import Button from 'components/atoms/Button';
import Dialog from 'components/widgets/Dialog';
import css from '../Apps.css';

const FIRST_APP_COMPLETE_IMAGE = '/static/dashboard/img/apps/add_app_complete.svg';
const ADD_MORE_PLATFORM_IMAGE = '/static/dashboard/img/apps/add_more_platform.svg';

export const ConfirmDialog = ({ confirmation, onAccept, onReject }) => (
    <Dialog open={!!confirmation} noPadding className={css.confirmDialog} onClose={onReject} onEscapePress={onReject}>
        <div className={css.confirmDialogContent}>
            <h3>{confirmation?.title}</h3>
            <p>{confirmation?.message}</p>
            <div className={css.confirmDialogActions}>
                <Button type="secondary" level="level2" onClick={onReject}>
                    <Translate id="STATIC.PAGES.VALIDATE_ACTION_MODAL.ACTION_NO" />
                </Button>
                <Button type="primary" level="level2" onClick={onAccept}>
                    {confirmation?.confirmLabel || <Translate id="STATIC.PAGES.APPS_CONFIGURATION.CONFIRM_ACTION" />}
                </Button>
            </div>
        </div>
    </Dialog>
);

ConfirmDialog.propTypes = {
    confirmation: PropTypes.shape({
        confirmLabel: PropTypes.node,
        message: PropTypes.node,
        onConfirm: PropTypes.func,
        title: PropTypes.node,
    }),
    onAccept: PropTypes.func.isRequired,
    onReject: PropTypes.func.isRequired,
};

export const FirstAppDialog = ({ prompt, isUnifiedUser, onAddPlatform, onClose, onContinue, onRedirect }) => {
    const isAddPlatformPrompt = prompt?.type === 'add-platform';

    return (
        <Dialog open={!!prompt} noPadding className={css.firstAppDialog} onClose={onClose} onEscapePress={onClose}>
            <div className={css.firstAppDialogContent}>
                {!isAddPlatformPrompt ? (
                    <button type="button" className={css.firstAppDialogClose} onClick={onClose}>
                        ×
                    </button>
                ) : null}
                <img src={isAddPlatformPrompt ? ADD_MORE_PLATFORM_IMAGE : FIRST_APP_COMPLETE_IMAGE} alt="" />
                <h3>
                    <Translate
                        id={
                            isAddPlatformPrompt
                                ? 'STATIC.POPOVERS.ADD_MORE_PLATFORM.CONGRATS'
                                : 'STATIC.POPOVERS.FIRST_APP_ADDED.CONGRATS'
                        }
                    />
                </h3>
                <p>
                    <Translate
                        id={
                            isAddPlatformPrompt
                                ? 'STATIC.POPOVERS.ADD_MORE_PLATFORM.MESSAGE'
                                : isUnifiedUser
                                ? 'STATIC.POPOVERS.FIRST_APP_ADDED.MESSAGE'
                                : 'STATIC.POPOVERS.FIRST_APP_ADDED.ANALYTICS_ONLY_MESSAGE'
                        }
                    />
                </p>
                <div className={css.firstAppDialogActions}>
                    {isAddPlatformPrompt ? (
                        <>
                            <Button type="secondary" level="level1" onClick={onContinue}>
                                <Translate id="STATIC.POPOVERS.ADD_MORE_PLATFORM.ONLY_ONE_PLATFORM_BUTTON" />
                            </Button>
                            <Button type="primary" level="level1" onClick={onAddPlatform}>
                                <Translate id="STATIC.POPOVERS.ADD_MORE_PLATFORM.ADD_ANOTHER_PLATFORM_BUTTON" />
                            </Button>
                        </>
                    ) : (
                        <>
                            <Button
                                type={isUnifiedUser ? 'secondary' : 'primary'}
                                level="level1"
                                onClick={() => onRedirect('data-sources')}
                            >
                                <Translate id="STATIC.POPOVERS.FIRST_APP_ADDED.ALTERNATIVE_BUTTON" />
                            </Button>
                            {isUnifiedUser ? (
                                <Button type="primary" level="level1" onClick={() => onRedirect('sdk_integration')}>
                                    <Translate id="STATIC.POPOVERS.FIRST_APP_ADDED.BUTTON" />
                                </Button>
                            ) : null}
                        </>
                    )}
                </div>
            </div>
        </Dialog>
    );
};

FirstAppDialog.propTypes = {
    isUnifiedUser: PropTypes.bool.isRequired,
    onAddPlatform: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onContinue: PropTypes.func.isRequired,
    onRedirect: PropTypes.func.isRequired,
    prompt: PropTypes.shape({
        appId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        firstPlatformName: PropTypes.string,
        type: PropTypes.string,
    }),
};
